import React, { useState, useEffect } from 'react';
import './TaskTimer.css';

function TaskTimer({ deadlineTimestamp, compact = false, completedBeforeGeneration = false }) {
  const [timeDisplay, setTimeDisplay] = useState('');
  const [timerClass, setTimerClass] = useState('');

  useEffect(() => {
    // Skip timer updates if task was completed early
    if (completedBeforeGeneration) {
      return;
    }
    
    const updateTimer = () => {
      const now = Date.now();
      const timeLeft = deadlineTimestamp * 1000 - now;

      if (timeLeft > 0) {
        // Time remaining
        const totalHours = Math.floor(timeLeft / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        const seconds = Math.floor((timeLeft / 1000) % 60);

        if (compact) {
          // Compact mode: show largest unit only
          if (totalHours > 0) {
            setTimeDisplay(`${totalHours}h`);
          } else if (minutes > 0) {
            setTimeDisplay(`${minutes}m`);
          } else {
            setTimeDisplay(`${seconds}s`);
          }
        } else {
          // Detailed mode: show HH:MM:SS
          const pad = (num) => String(num).padStart(2, '0');
          setTimeDisplay(`Time left: ${pad(totalHours)}:${pad(minutes)}:${pad(seconds)}`);
        }

        // Color coding based on time left
        if (timeLeft > 3600000) {
          // > 1 hour
          setTimerClass('timer-green');
        } else {
          // < 1 hour
          setTimerClass('timer-orange');
        }
      } else {
        // Overdue
        const overdue = Math.abs(timeLeft);
        const totalHours = Math.floor(overdue / (1000 * 60 * 60));
        const minutes = Math.floor((overdue / (1000 * 60)) % 60);
        const seconds = Math.floor((overdue / 1000) % 60);

        if (compact) {
          setTimeDisplay('Overdue');
        } else {
          const pad = (num) => String(num).padStart(2, '0');
          setTimeDisplay(`Overdue: ${pad(totalHours)}:${pad(minutes)}:${pad(seconds)}`);
        }

        setTimerClass('timer-red');
      }
    };

    // Update immediately
    updateTimer();

    // Update every second
    const interval = setInterval(updateTimer, 1000);

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, [deadlineTimestamp, compact, completedBeforeGeneration]);

  // Show checkmark for tasks completed before generation
  if (completedBeforeGeneration) {
    return (
      <div className={`task-timer timer-checkmark ${compact ? 'compact' : 'detailed'}`}>
        ✓
      </div>
    );
  }

  return (
    <div className={`task-timer ${timerClass} ${compact ? 'compact' : 'detailed'}`}>
      {timeDisplay}
    </div>
  );
}

export default TaskTimer;

